import React, { createContext, useState, useContext, useEffect } from 'react';
import { getImageUrl } from '../utils/urlUtils';
import { apiFetch } from '../utils/api';

const SiteSettingsContext = createContext();

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return context;
};

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = '';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '');
    }
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await apiFetch('/api/site-settings');
      if (response.ok) {
        const data = await response.json();
        setSettings(data);
        applySettings(data);
      }
    } catch (error) {
      console.error('Error fetching site settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const applySettings = (settingsData) => {
    if (settingsData.site_name && !window.location.pathname.includes('/dashboard')) {
      document.title = settingsData.site_name;
    }
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    if (settingsData.site_description) {
      metaDescription.setAttribute('content', settingsData.site_description);
    }
    if (settingsData.favicon_url) {
      let favicon = document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.setAttribute('rel', 'icon');
        document.head.appendChild(favicon);
      }
      const faviconUrl = settingsData.favicon_url.startsWith('http') 
        ? settingsData.favicon_url 
        : getImageUrl(settingsData.favicon_url);
      favicon.setAttribute('href', faviconUrl);
    }
  };

  const refreshSettings = () => {
    fetchSettings();
  };

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};
